/* eslint @typescript-eslint/no-explicit-any: 0 */

import React from 'react';

import ClothingMenuItem from './ClothingMenuItem';
import MenuItem from './MenuItem';

const Menu = ({ menu = [] }: { menu: any }) => {
  return (
    <nav className="main-header__nav">
      <ul className="main-header__nav__top-list">
        {menu.map((props: any, i: number) => (
          <React.Fragment key={props.slug}>
            {props?.content?.footwear?.title === 'Clothing' ? (
              <ClothingMenuItem
                {...props}
                content={props.content}
                position={i + 1}
                track={true}
                pagePosition="Header"
              />
            ) : (
              <MenuItem
                {...props}
                content={props.content}
                position={i + 1}
                track={true}
                pagePosition="Header"
              />
            )}
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
};

export default Menu;
